function downloadFile(csv, filename, typeObj = {
    type: 'text/csv;charset=utf-8;'
}) {
if(typeObj.type==='application/json'){
    csv=JSON.stringify(csv);
}
    // Create a Blob object with the CSV data
    const blob = new Blob([csv], typeObj);

    // Create a temporary anchor element
    const link = document.createElement('a');
    if (link.download !== undefined) {
        // Set the anchor's href to the Blob object
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);

        // Programmatically click the anchor element to trigger the download
        link.click();
        URL.revokeObjectURL(url);
    } else {
        console.log('Anchor "download" attribute is not supported in this browser.');
    }
}

export default downloadFile
